//UI
import Box from '../ui/Box'

// Mantine
import { Button, Anchor } from '@mantine/core'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// React
import { useState, useEffect } from 'react'

export default function ComponentWatchHeadWarranty({
    component,
    editComponentHandlers,
}) {
    const { requestGet } = useAxiosApi()
    const [warrantyCount, setWarrantyCount] = useState(null)

    useEffect(() => {
        const fetchCount = async () => {
            const { data } = await requestGet('/warranties/count', {
                component_id: component.id,
            })

            setWarrantyCount(data.count)
        }

        fetchCount()
    }, [component.id])

    const rightSection = (
        <Button variant="default" onClick={editComponentHandlers.open}>
            Modifier
        </Button>
    )

    const warrantyTableUrl = `/warranties?component_id=${component.id}`

    return (
        <Box title="Garanties" rightSection={rightSection}>
            <div className="flex flex-col gap-2">
                <div className="flex flex-col items-start">
                    <span className="text-gray-500 text-sm">
                        Garanties associées
                    </span>

                    <Anchor href={warrantyTableUrl}>
                        {warrantyCount ?? 0} garantie
                        {warrantyCount !== 1 ? 's' : ''}
                    </Anchor>
                </div>

                <div className="flex flex-col">
                    <span className="text-gray-500 text-sm">
                        Visible par tous les revendeurs
                    </span>

                    <span className="font-medium">
                        {component.warranty_visible_by_all_retailers
                            ? 'Oui'
                            : 'Non'}
                    </span>
                </div>

                <div className="flex flex-col">
                    <span className="text-gray-500 text-sm">
                        Visible sur le formulaire de contact du site
                    </span>

                    <span className="font-medium">
                        {component.warranty_visible_on_website_contact
                            ? 'Oui'
                            : 'Non'}
                    </span>
                </div>

                <div className="flex flex-col items-start">
                    <span className="text-gray-500 text-sm">
                        Guide d'utilisation
                    </span>

                    {component.watch_guide_url ? (
                        <Anchor
                            href={`https://baltic-watches.com${component.watch_guide_url}`}
                            target="_blank"
                        >
                            {component.watch_guide_url}
                        </Anchor>
                    ) : (
                        <span className="font-medium">Aucun</span>
                    )}
                </div>
            </div>
        </Box>
    )
}
